exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Thermometer-module__wrapper___1vkgT{display:grid;justify-content:center;justify-items:center}.Thermometer-module__wrapper___1vkgT button{background-color:#1368e5;color:#fff;width:200px;height:40px;border-radius:4px;padding:0 1rem;display:grid;grid-template-columns:auto 1fr;align-items:center}.Thermometer-module__wrapper___1vkgT button svg{opacity:.5}.Thermometer-module__svg___33GX5{height:450px}.Thermometer-module__svg___33GX5.Thermometer-module__viewing___PxsU2 .Thermometer-module__clickable___1HuJ8{cursor:auto!important}.Thermometer-module__svg___33GX5.Thermometer-module__viewing___PxsU2 *{pointer-events:none}.Thermometer-module__clickable___1HuJ8{cursor:pointer}", ""]);

// exports
exports.locals = {
	"wrapper": "Thermometer-module__wrapper___1vkgT",
	"svg": "Thermometer-module__svg___33GX5",
	"viewing": "Thermometer-module__viewing___PxsU2",
	"clickable": "Thermometer-module__clickable___1HuJ8"
};